import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import { PageHeader, Section } from '../components/Page';
import { tokens } from '../theme';

const PILLARS = [
  {
    title: 'Built for AST',
    body: 'Internal products tailored to Advanced Substrate Technologies — brand, process, and shop-floor reality.',
  },
  {
    title: 'Edge-first delivery',
    body: 'Cloudflare Pages, Workers, D1, and R2 for low-latency intranet apps that stay inside Zero Trust.',
  },
  {
    title: 'Department partners',
    body: 'General tools for everyone, IT Hub for delivery standups, Traceboard for Production Control.',
  },
  {
    title: 'Request & ship',
    body: 'Need something custom? Book an intake appointment, track status, and we build with you.',
  },
];

export function AboutPage() {
  return (
    <>
      <PageHeader
        title="About IT Lab"
        subtitle="The internal product studio of Advanced Substrate Technologies Pte. Ltd."
      />

      <Section>
        <Stack spacing={8}>
          <Typography
            component="p"
            sx={{ fontSize: { xs: 24, md: 32 }, lineHeight: 1.3, fontWeight: 700, letterSpacing: '-0.02em', color: tokens.ink, maxWidth: 900 }}
          >
            We design and ship intranet applications — from brand-locked slide drafting to weekly IT delivery
            tracking and production MES visibility — so every department can move faster on a shared stack.
          </Typography>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' }, gap: 4 }}>
            {PILLARS.map((p) => (
              <Stack key={p.title} spacing={1} sx={{ pt: 2, borderTop: `3px solid ${tokens.blue}` }}>
                <Typography variant="h3" fontSize={20}>
                  {p.title}
                </Typography>
                <Typography color="text.secondary">{p.body}</Typography>
              </Stack>
            ))}
          </Box>
        </Stack>
      </Section>

      <Section band="subtle" py={{ xs: 6, md: 9 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} gap={5} justifyContent="space-between" alignItems={{ md: 'center' }}>
          <Stack spacing={1.5} maxWidth={640}>
            <Typography variant="h2" fontSize={28}>
              How we work with departments
            </Typography>
            <Typography color="text.secondary">
              Start with the catalog to see what already exists. If you need a new workflow, submit a request
              with a preferred appointment date. We review it, schedule a short intake, and track delivery on
              this portal — alongside the status page for each live service.
            </Typography>
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} gap={2} flex="none">
            <Button component={RouterLink} to="/apps" variant="contained" size="large">
              Browse applications
            </Button>
            <Button component={RouterLink} to="/request" variant="outlined" size="large">
              Request an app
            </Button>
          </Stack>
        </Stack>
      </Section>
    </>
  );
}
